import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { MdClose, MdFullscreen } from "react-icons/md";
import ChevronRight from "@mui/icons-material/ChevronRight";
import GalleryVenue from "../venuePreview/GalleryVenue";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";

const HeroSection = ({
	imagesData = [],
	allVideo,
	basicDetails,
	breadcrumbPath,
}) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const [isModalOpen, setIsModalOpen] = useState(false); // State for modal
	const [data, setData] = useState("");
	const [videos, setVideos] = useState("");
	const [basicInfo, setBasicInfo] = useState("");

	useEffect(() => {
		setData(imagesData);
		setVideos(allVideo);
		setBasicInfo(basicDetails);
	}, [imagesData, allVideo, basicDetails]);

	// Toggle modal visibility
	const handleExpandClick = () => {
		setIsExpanded(!isExpanded);
	};

	// Open the modal with all photos
	const handleShowAllPhotos = (index = null) => {
		setIsModalOpen(true);
		if (index || index === 0) setActiveIndex(index);
	};

	// Close the modal
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const toggleFullScreen = () => {
		const elem = document.querySelector(".custom-carousel");
		if (!document.fullscreenElement) {
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.webkitRequestFullscreen) {
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) {
				elem.msRequestFullscreen();
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		}
	};

	return (
		<div className="sm:p-6 pb-6 p-0">
			{/* Main image and right side images */}
			<div className="hidden sm:flex justify-start items-center gap-1 mb-4 lg:gap-0 lg:px-6 px-0">
				{breadcrumbPath.map((crumb, index) => (
					<React.Fragment key={index}>
						{crumb.to ? (
							<Link
								to={crumb.to}
								className={`text-[14px] ${
									index === breadcrumbPath.length - 1
										? "text-[#000000]"
										: "text-[#b0b0b0]"
								}`}
							>
								{crumb.name}
							</Link>
						) : (
							<span
								className={`text-[14px] ${
									index === breadcrumbPath.length - 1
										? "text-[#000000]"
										: "text-[#b0b0b0]"
								}`}
							>
								{crumb.name}
							</span>
						)}
						{index < breadcrumbPath.length - 1 && (
							<ChevronRight
								style={{
									fontSize: "22px",
									color: "#b0b0b0",
								}}
							/>
						)}
					</React.Fragment>
				))}
			</div>
			<GalleryVenue
				photos={data}
				videos={videos}
				handleExpandClick={handleExpandClick}
				handleShowAllPhotos={handleShowAllPhotos}
			/>

			{/* Modal for showing all photos */}
			{isModalOpen && (
				<div className="custom-carousel z-[5000] fixed inset-0 bg-black/80 flex items-center justify-center">
					<div className="absolute top-2 left-1/2 -translate-x-1/2 flex items-center justify-center space-x-8 text-white z-[6000] w-full">
						<p className="text-[16px]">
							{`${activeIndex + 1} / ${data?.length + videos?.length}`}
						</p>
						<div className="flex gap-x-2">
							<button onClick={toggleFullScreen} className="text-lg">
								<MdFullscreen />
							</button>
							<button onClick={handleCloseModal} className="text-lg">
								<MdClose />
							</button>
						</div>
					</div>
					{/* <Carousel
						selectedItem={activeIndex}
						showArrows={true}
						onChange={(index) => setActiveIndex(index)}
						showThumbs={true}
						showStatus={false}
						infiniteLoop
						className="custom-carousel text-white"
						showIndicators={false}
						renderArrowPrev={(onClickHandler, hasPrev, label) => {
							return (
								<>
									{hasPrev && (
										<button
											type="button"
											onClick={onClickHandler}
											title={label}
											className="text-white absolute top-1/2 left-2 lg:left-10 z-50"
										>
											<FaCaretLeft className="size-5" />
										</button>
									)}
								</>
							);
						}}
						renderArrowNext={(onClickHandler, hasNext, label) => {
							return (
								<>
									{hasNext && (
										<button
											type="button"
											onClick={onClickHandler}
											title={label}
											className="text-white absolute  top-1/2 right-2 lg:right-10 z-50"
										>
											<FaCaretRight className="size-5" />
										</button>
									)}
								</>
							);
						}}
						renderThumbs={() => [
							...imagesData?.map((image, index) => (
								<img
									key={`thumb-${index}`}
									src={image}
									alt={`Thumbnail ${index}`}
									className="object-cover w-full h-full rounded"
								/>
							)),
							...videos?.map((video, index) => {
								const isYouTubeLink =
									video.includes("youtube.com") || video.includes("youtu.be");

								return isYouTubeLink ? (
									<img
										key={`thumb-video-${index}`}
										src={`https://img.youtube.com/vi/${
											video.split("v=")[1] || video.split("/").pop()
										}/0.jpg`} // YouTube video thumbnail
										alt={`Video Thumbnail ${index}`}
										className="object-cover w-full h-full rounded"
									/>
								) : (
									<img
										key={`thumb-video-${index}`}
										src="/video-thumbnail-placeholder.png" // Placeholder for MP4 videos
										alt={`Video Thumbnail ${index}`}
										className="object-cover w-full h-full rounded"
									/>
								);
							}),
						]}
					>
						{[...(imagesData || []), ...(videos || [])].map((item, index) => {
							const isVideo =
								item.includes("youtube.com") ||
								item.includes("youtu.be") ||
								item.endsWith(".mp4");

							if (isVideo) {
								const isYouTube =
									item.includes("youtube.com") || item.includes("youtu.be");
								const videoId =
									item.split("v=")[1]?.split("&")[0] || item.split("/").pop();

								return isYouTube ? (
									<div
										key={`yt-${index}`}
										className="w-[90%] sm:w-[69%] m-auto h-[590px] relative mb-1"
									>
										<iframe
											className="rounded-lg w-full h-full object-cover"
											src={`https://www.youtube.com/embed/${videoId}`}
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowFullScreen
											title={`YouTube Video ${index}`}
										/>
									</div>
								) : (
									<video
										key={`mp4-${index}`}
										className="rounded-lg mb-4 sm:w-[69%] h-[590px] w-full object-cover mx-auto"
										controls
										preload="metadata"
										onLoadedMetadata={(e) => (e.target.currentTime = 1)}
									>
										<source src={item} type="video/mp4" />
										Your browser does not support the video tag.
									</video>
								);
							}

							return (
								<div
									key={`image-${index}`}
									className="md:h-[556px] h-[228px] max-h-[566px] max-w-full flex justify-center items-center"
								>
									<img
										src={item}
										alt={`Media ${index}`}
										className="object-contain h-full w-full"
									/>
								</div>
							);
						})}
					</Carousel> */}
					<div className="w-[90%] max-w-[1200px] mx-auto">
						<Carousel
							selectedItem={activeIndex}
							showArrows={true}
							renderArrowPrev={(onClickHandler, hasPrev, label) => {
								return (
									<>
										{hasPrev && (
											<button
												type="button"
												onClick={onClickHandler}
												title={label}
												className="text-white absolute top-1/2 left-2 lg:left-10 z-50"
											>
												<FaCaretLeft className="size-5" />
											</button>
										)}
									</>
								);
							}}
							renderArrowNext={(onClickHandler, hasNext, label) => {
								return (
									<>
										{hasNext && (
											<button
												type="button"
												onClick={onClickHandler}
												title={label}
												className="text-white absolute  top-1/2 right-2 lg:right-10 z-50"
											>
												<FaCaretRight className="size-5" />
											</button>
										)}
									</>
								);
							}}
							onChange={(index) => setActiveIndex(index)}
							showThumbs={true}
							showStatus={false}
							infiniteLoop={false}
							className="custom-carousel text-white"
							showIndicators={false}
							renderThumbs={() => [
								...data?.map((image, index) => (
									<img
										key={`thumb-${index}`}
										src={image}
										alt={`Thumbnail ${index}`}
										className="object-cover w-full h-full rounded"
									/>
								)),
								...videos?.map((video, index) => {
									const isYouTubeLink =
										video.includes("youtube.com") || video.includes("youtu.be");

									return isYouTubeLink ? (
										<img
											key={`thumb-video-${index}`}
											src={`https://img.youtube.com/vi/${
												video.split("v=")[1] || video.split("/").pop()
											}/0.jpg`} // YouTube video thumbnail
											alt={`Video Thumbnail ${index}`}
											className="object-cover w-full h-full rounded"
										/>
									) : (
										<img
											key={`thumb-video-${index}`}
											src="/video-thumbnail-placeholder.png" // Placeholder for MP4 videos
											alt={`Video Thumbnail ${index}`}
											className="object-cover w-full h-full rounded"
										/>
									);
								}),
							]}
						>
							{[...(data || []), ...(videos || [])].map((item, index) => {
								const isVideo =
									item.includes("youtube.com") ||
									item.includes("youtu.be") ||
									item.endsWith(".mp4");

								if (isVideo) {
									const isYouTube =
										item.includes("youtube.com") || item.includes("youtu.be");
									const videoId =
										item.split("v=")[1]?.split("&")[0] || item.split("/").pop();

									return isYouTube ? (
										<div
											key={`yt-${index}`}
											className="w-[90%] sm:w-[69%] m-auto h-[590px] relative mb-1"
										>
											<iframe
												className="rounded-lg w-full h-full object-cover"
												src={`https://www.youtube.com/embed/${videoId}`}
												frameBorder="0"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
												allowFullScreen
												title={`YouTube Video ${index}`}
											/>
										</div>
									) : (
										<video
											key={`mp4-${index}`}
											className="rounded-lg mb-4 sm:w-[69%] h-[590px] w-full object-cover mx-auto"
											controls
											preload="metadata"
											onLoadedMetadata={(e) => (e.target.currentTime = 1)}
										>
											<source src={item} type="video/mp4" />
											Your browser does not support the video tag.
										</video>
									);
								}

								return (
									<div
										key={`image-${index}`}
										className="md:h-[556px] h-[228px] max-h-[566px] max-w-full flex justify-center items-center"
									>
										<img
											src={item}
											alt={`Media ${index}`}
											className="object-contain h-full w-full"
										/>
									</div>
								);
							})}
						</Carousel>
					</div>
				</div>
			)}
		</div>
	);
};

export default HeroSection;
